// Typed error for provider operations. Per
// application-architecture.md §9, provider errors bubble as
// `ProviderError { code, retriable, retryAfter }` so the client
// retry logic can back off with exponential + Retry-After semantics.
export class ProviderError extends Error {
    code;
    retriable;
    retryAfter;
    constructor(message, init) {
        super(message, { cause: init.cause });
        this.name = this.constructor.name;
        this.code = init.code;
        this.retriable = init.retriable ?? false;
        if (init.retryAfter !== undefined) {
            this.retryAfter = init.retryAfter;
        }
    }
}
//# sourceMappingURL=errors.js.map